
<template>
  <div class="login">
    <v-card style="padding: 20px" class="mx-auto mt-5">
      <v-card-title>
        <h2 style="color:darkgreen;">Player Profile</h2>
      </v-card-title>

      <v-card-text style="margin-top:20px;margin-bottom:20px;">
        <b>User Name:</b> {{player.userid}}<br>
        <b>Role:</b> {{player.role}}<br>
        <b>Default Flight:</b> {{player.defaultFlight}}<br/>
        <b>Default Handicap:</b> {{player.handicap}}<br/>
      </v-card-text>

      <v-form>
        <v-card-text>
          <v-text-field class="myinput first-name" label="First Name" v-model="player.firstName"/>
          <v-text-field class="myinput middle-name" label="Middle Name" v-model="player.middleName"/>
          <v-text-field class="myinput last-name" label="Last Name" v-model="player.lastName"/>
          <v-text-field class="myinput last-name" label="Nick Name" v-model="player.nickName"/>
        </v-card-text>

        <v-card-text>
          <v-text-field class="myinput email" label="Email Address" v-model="player.emailAddress"/>
          <v-text-field class="myinput phone" label="Phone" v-model="player.phone"/>
          <v-text-field class="myinput phone" label="Cell Phone" v-model="player.cellPhone"/>
        </v-card-text>

        <v-card-text>
          <v-text-field class="myinput phone" label="Member Since" v-model="player.memberSince"/>
        </v-card-text>

        <v-card-text style="margin-top:20px;">
          <b>Shirt Size: </b>
          <select class="dropdown" v-model="player.shirtSize">
            <option value="Select Size">Select Size</option>
            <option value="X-Small">X-Small</option>
            <option value="Small">Small</option>
            <option value="Medium">Medium</option>
            <option value="Large">Large</option>
            <option value="X-Large">X-Large</option>
          </select>
        </v-card-text>

      </v-form>

      <v-divider style="margin-top: 30px"></v-divider>

      <v-card-actions class="card-actions">
        <v-btn style="background-color:darkgreen;color:white;" @click="formSubmit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      showPassword: false,
      player: null,
      confirmPassword: ''
    }),
    mounted: function() {
      var _this = this;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.axios.get('/api/players/'+id)
        .then(function (response) {
            _this.player = response.data;
        })
        .catch(function (error) {
            console.log('ERROR 7: ' + error);
        });
      } else {
         var userInfo = this.$AuthSvc.getUserInfo();
        _this.axios.get('/api/players/'+userInfo.playerId)
        .then(function (response) {
            _this.player = response.data;
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      }
    },
    methods: {
      forgotPassword: function() {
        console.log('FORGOTy PASSWORD');
      },
      formSubmit() {
          this.axios.put('/api/players', this.player)
          .then(function (response) {
              console.log('DATA: ' + response.data);
              swal({
                  title: "Success",
                  text: "Profile saved successfully.",
                  type: "success"
              }).then(function() {
                  window.location = "/home";
              });
           })
          .catch(function (error) {
              console.log(error);
              swal("Error", "able to save your profile.", "error");
          });
      }
    }
  }
</script>

<style scoped>
  .v-card {
    background-color: #e6f2ea;
  }

  .login {
    margin-top: 12px;
    width: 100%;
  }

  .card-actions {
    margin-top: 20px;
  }

  @media (min-width: 768px) {

    .myinput {
      display: inline-block;
      float: left;
      margin-right: 20px;
    }

    .first-name, .middle-name, .last-name {
      width: 200px !important;
    }

    .email {
      width: 300px !important;
    }

    .v-card__text {
      display: inline-block !important;
      width: 100% important;

    }
  }

</style>